module.exports = __webpack_public_path__ + "media/offers_icons/motocykle-blue-b72db949.svg";